export default __webpack_public_path__ + "static/media/property_1_18.182dd0e6.webp";